import React from "react";
import { useSiteData } from "@/context/SiteDataContext";
import Title from "@/components/shared/Title";
import BlogCard from "@/components/shared/BlogCard"; // Import BlogCard
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi"; // Import icon for the button
import Button from "@/components/shared/Button";
const BlogsSection = () => {
  const { siteData, loading } = useSiteData();
  const blogs = siteData?.blogs || [];

  if (loading)
    return <p className="py-10 text-center">Loading blog posts...</p>;

  return (
    <section className="px-4 py-12 text-center md:px-12 xl:px-16">
      <div className="flex flex-col items-center">
        <Title title="Our Blogs" className="mb-6 xl:mb-12" />
      </div>

      <h2 className="text-dark mb-6 text-2xl font-semibold md:text-4xl xl:mb-12">
        Explore expert tips and updates in <br className="hidden lg:block" />
        research and statistics.
      </h2>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {blogs.slice(0, 6).map((blog, index) => (
          <BlogCard key={index} blog={blog} /> // Using BlogCard component
        ))}
      </div>

      <Button
        text="Discover All Blogs"
        url="/blogs"
        className="mt-16 justify-self-center"
        icon
      />
    </section>
  );
};

export default BlogsSection;
